const MOBILE_NAV_MQ = window.matchMedia("(max-width: 75em)")

export function initSiteNav() {
  const menuBtn = document.getElementById("site-menu-btn")
  const nav = document.getElementById("site-nav")
  const headerRight = document.querySelector(".site-header__right")
  if (!menuBtn || !nav || !headerRight) return

  let backdrop = document.querySelector(".site-menu-backdrop")
  if (!backdrop) {
    backdrop = document.createElement("div")
    backdrop.className = "site-menu-backdrop"
    backdrop.setAttribute("aria-hidden", "true")
    document.body.appendChild(backdrop)
    backdrop.addEventListener("click", () => setMenuOpen(false))
  }

  const setMenuOpen = (open) => {
    nav.classList.toggle("is-open", open)
    menuBtn.classList.toggle("is-active", open)
    menuBtn.setAttribute("aria-expanded", open ? "true" : "false")
    document.body.classList.toggle("site-menu-open", open)
    backdrop.classList.toggle("is-open", open)
  }

  const ensureDrawerChrome = () => {
    if (!nav.querySelector(".site-header__drawer-head")) {
      const head = document.createElement("div")
      head.className = "site-header__drawer-head"
      head.innerHTML = `
        <p class="site-header__drawer-title" id="nav-drawer-title">Menu</p>
        <button type="button" class="site-header__close" id="site-menu-close" aria-label="Close">
          <span class="site-header__close-icon" aria-hidden="true"></span>
        </button>`
      nav.insertBefore(head, nav.firstChild)
      document.getElementById("site-menu-close")?.addEventListener("click", () => setMenuOpen(false))
    }

    let lang = headerRight.querySelector(".site-header__lang")
    if (!lang) lang = nav.querySelector(".site-header__drawer-foot .site-header__lang")

    if (lang && !nav.querySelector(".site-header__drawer-foot")) {
      const foot = document.createElement("div")
      foot.className = "site-header__drawer-foot"
      foot.appendChild(lang)
      nav.appendChild(foot)
    }
  }

  const syncNavPlacement = () => {
    if (MOBILE_NAV_MQ.matches) {
      ensureDrawerChrome()
      if (nav.parentElement !== document.body) document.body.appendChild(nav)
      nav.classList.add("is-drawer")
      return
    }

    setMenuOpen(false)
    nav.classList.remove("is-drawer")

    const lang = nav.querySelector(".site-header__lang")
    if (lang && lang.parentElement !== headerRight) headerRight.appendChild(lang)

    if (nav.parentElement !== headerRight) headerRight.insertBefore(nav, menuBtn)
  }

  menuBtn.addEventListener("click", () => setMenuOpen(!nav.classList.contains("is-open")))
  nav.querySelectorAll("a").forEach((a) => a.addEventListener("click", () => setMenuOpen(false)))

  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape" && nav.classList.contains("is-open")) setMenuOpen(false)
  })

  MOBILE_NAV_MQ.addEventListener("change", syncNavPlacement)
  document.addEventListener("napire-lang-updated", () => {
    const n = window.dafaultLanguage?.nav
    const lang = document.documentElement.lang === "en" ? "en" : "ja"
    if (!n) return
    const t = (o) => (o && o[lang]) || ""
    const title = document.getElementById("nav-drawer-title")
    if (title) title.textContent = t(n.drawerTitle)
    const close = document.getElementById("site-menu-close")
    if (close) close.setAttribute("aria-label", t(n.close))
    menuBtn.setAttribute("aria-label", t(n.menuOpen))
  })

  syncNavPlacement()
}

export default initSiteNav
